import { createTheme } from '@mui/material/styles';

// Create MUI theme following CLAUDE.md patterns
export const theme = createTheme({
  typography: {
    fontFamily: "var(--font-family)",
    h1: {
      fontSize: "var(--heading-h1-font-size)",
      fontWeight: "var(--heading-h1-semibold-font-weight)",
      lineHeight: "var(--heading-h1-line-height)",
      letterSpacing: "var(--heading-h1-letter-spacing)",
      fontFeatureSettings: "'salt' on",
    },
    h2: {
      fontSize: "var(--heading-h2-font-size)",
      fontWeight: "var(--heading-h2-semibold-font-weight)",
      lineHeight: "var(--heading-h2-line-height)",
      letterSpacing: "var(--heading-h2-letter-spacing)",
      fontFeatureSettings: "'salt' on",
    },
    h3: {
      fontSize: 32,
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h4: {
      fontSize: "var(--heading-h4-font-size)",
      fontWeight: "var(--heading-h4-semibold-font-weight)",
      lineHeight: "var(--heading-h4-line-height)",
      letterSpacing: "var(--heading-h4-letter-spacing)",
      fontFeatureSettings: "'salt' on",
    },
    h5: {
      fontSize: 22,
      fontWeight: 600,
      lineHeight: "27px",
      letterSpacing: "0.22px",
    },
    h6: {
      fontSize: 18,
      fontWeight: 400,
      lineHeight: 1.5,
    },
    body1: {
      fontSize: "var(--paragraph-p1-font-size)",
      fontWeight: "var(--paragraph-p1-regular-font-weight)",
      lineHeight: "var(--paragraph-p1-line-height)",
      letterSpacing: "var(--paragraph-p1-letter-spacing)",
      fontFeatureSettings: "'salt' on",
    },
    body2: {
      fontSize: "var(--paragraph-p2-font-size)",
      fontWeight: "var(--paragraph-p2-regular-font-weight)",
      lineHeight: "var(--paragraph-p2-line-height)",
      letterSpacing: "var(--paragraph-p2-letter-spacing)",
      fontFeatureSettings: "'salt' on",
    },
    caption: {
      fontSize: 14,
      fontWeight: 400,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});